<template>
<v-row justify="center">
<v-dialog v-model="dialog_local" max-width="650">
    <v-form ref="ct" action="#" @submit.prevent="beforeCreateForm('edit')" lazy-validation>
        <v-card class="mx-auto" tile>
        <v-card-title class="justify-space-between" style="background-color: #3D348B; color: white; padding-top: 5px; padding-bottom: 5px">
            WhatsApp {{` ${modalInfo.ID}`}}
            <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
            </v-card-title>
        <v-card-text>
        <v-container class="fill-height"
        fluid >
            <v-row>
                <!--
                    ID, Mobile No., Template ID, Message Template Name, Message Body, Image, Created Date, Sent Status, Sent Date
                -->
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.ID"
                        label="ID"
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.phoneNumber"
                        label="Mobile No."
                        required
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.templateID"
                        label="Template ID"
                        required
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.templateName"
                        label="Message Template Name"
                        required
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="z-index: 1">
                    <span class="text-body-2">Message Body</span>
                    <text-editor v-if="!modal_loader" v-model="modalInfo.message" :color="'white'" :isEditing="!readonly"></text-editor>
                </v-col>
                <!--
                <v-col cols="12" md="12">
                    <span class="text-body-2">Image</span><br/>
                    <img v-if="modalInfo.imageURL !== null" style="border: 1px solid #191716" width="100%" :src="modalInfo.imageURL" />
                    <span v-else class="text-body-2">N/A</span>
                </v-col>
                -->
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.createdDate"
                        label="Created Date"
                        required
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.statusName"
                        label="Sent Status"
                        required
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                    <v-text-field
                        dense
                        outlined
                        :value="modalInfo.sentDate"
                        label="Sent Date"
                        required
                        disabled
                        hide-details="auto"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn v-if="false" tile type="submit" small color="primary"><v-icon left x-small dark>fa fa-save</v-icon>Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn tile color="blue darken-1" text @click="$emit('closed', false)">Close</v-btn>
        </v-card-actions>
        </v-card>
    </v-form>
    <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
    <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
    </v-snackbar>
</v-dialog>
</v-row>
</template>
<script>
import alertbox from './Alert';
import {ERR} from '../../assets/js/errhandle.js';
import {rule} from '../../assets/js/checkPerm';
import TextEditor from '../TextEditor';

export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master', 'allInfo', 'readonly'],
    
    data()  {
        return {
            dialog_local: false,
            innerModal: false,
            form: {
                TemplateText: {item: '', rule: []},
                PlaceholderCount: {item: '', rule: []},
                ApprovedByTwilio: {item: false}
            },

            btn_loading: false,

            roles: [],
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                edit_modal: false,
                view_modal: false,
                confirmEdit: false,
                confirmCreate: false,
            },
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            modal_loader: false,
            notificationmessage: '',
            bodyhint: 'Template content can not be changed after approved except placeholder values inside double curly braces ({{...}}) when the message is sent.'
        }
    },

    components: {alertbox, 'text-editor': TextEditor},

    watch: {
        dialog: {
        handler: async function(value) {
            await this.modalHandler();
            if(value == true){
                this.modal_loader = true;
                await this.handleValue();
                this.modal_loader = false;
                this.btn_loading = false;
            }
        },
        },

        dialog_local: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    methods: {
        async onRuleChange(after, before) {
            this.form.TemplateText.rule = [];
            this.form.PlaceholderCount.rule = [];
        },

        async beforeCreateForm(flag){
            this.form.TemplateText.rule = [
                v => !!v || 'This is required',
            ];

            this.form.PlaceholderCount.rule = [
                v => !!v || 'This is required',
                v => Number.isInteger(Number(v)) || 'Only whole number is allowed',
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.ct.validate()) {
                    self.innerModal = true;
                    self.ma.modalInfo = {id: 1, name: 2};
                    self.ma.modal_action_type = flag;
                }
            });
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        modalHandler(){
            this.dialog_local = !this.dialog_local;
        },

        modalCloseHandler(){
            if (this.dialog_local == false){
                this.$emit('closed', false);
            }
        },

        async handleValue(){
            this.onRuleChange();
            this.form.PlaceholderCount.item = this.modalInfo.PlaceholderCount;
            this.form.TemplateText.item = this.modalInfo.TemplateText;
            this.form.ApprovedByTwilio.item = this.modalInfo.ApprovedByTwilio;
        },

        handleDelete(value){
            this.innerModal = true;
            this.ma.modal_action_type = value;
        },

        //set the action to be sent to watcher to execute the create/edit function
        async onConfirm(value){
                if (this.ma.modal_action_type == 'edit'){
                    this.form.flag = 'update';
                    this.$emit('confirm', this.form);
                }

                if (this.ma.modal_action_type == 'delete'){
                    this.form.flag = 'delete';
                    this.$emit('delete');
                }

                this.innerModal = false;
        },

        onClosed(value){
            if (value == false){
                this.innerModal = value;
            }
        },
    }
}
</script>